document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('br').forEach(br => {
    br.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('.header__submenu.list-menu').forEach(mn => {
    mn.removeAttribute('tabindex');
  });

  document.querySelectorAll('hr').forEach(hr => {
    hr.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('.predictive-search__list-item').forEach(lis => {
    lis.removeAttribute('role');
  });

  document.querySelectorAll('.predictive-search__results-list').forEach(ul => {
    ul.removeAttribute('role');
  });

  document.querySelectorAll('img[src="https://cdn.shopify.com/s/files/1/0706/8431/1859/files/Clarks_banner.jpg?v=1745525228"]').forEach(img => {
  img.setAttribute('alt', 'A promotional banner for Clarks featuring their logo in white script on a dark background next to a person wearing brown leather Wallabee boots.');
  });

  document.querySelectorAll('hr').forEach(hr => {
    hr.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll(
  'a[href="https://cooljsmiami.com/customer_authentication/redirect?locale=en&region_country=US"]'
  ).forEach(link => {
  link.setAttribute("target", "_blank");
  link.setAttribute(
    "aria-label",
    "Log in, This link will open in a new tab"
  );
 });

  // Select all matching anchors
 document.querySelectorAll('.facets__label.facet-checkbox svg')
  .forEach(svg => svg.setAttribute('aria-hidden', 'true'));

  document.querySelectorAll('a')
  .forEach(link => {
    if (link.href.includes('https://cooljsmiami.com/')) {
      link.removeAttribute('target');
      // Optional: remove rel="noopener" if needed
      // link.removeAttribute('rel');
    }
  });

});

  // External Links Warning
 document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');

    const excludedLinks = [
      'https://www.facebook.com/vivarawpets',
      'https://www.instagram.com/vivarawpets/',
      'https://www.tiktok.com/@vivarawpets'
    ];

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  handleExternalLinks();
});

 // Email and phone number labels
 document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  handleContactLinks();
});

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const links = document.querySelectorAll('.full-unstyled-link');
    links.forEach(link => link.removeAttribute('aria-labelledby'));
  }, 500);

const headings = document.querySelectorAll('h2.rich-text__heading');

headings.forEach(heading => {
  // Check if the heading is empty (no text or only whitespace)
  if (!heading.textContent.trim()) {
    heading.remove(); // Remove the empty heading
  }
});

});

// Image Accessibility in Product Media Modal
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".product-media-modal__content");

  if (!container) return;

  const images = container.querySelectorAll("img");
  const totalImages = images.length;

  images.forEach((img, index) => {
    // Get existing alt text and trim whitespace
    let currentAlt = img.getAttribute("alt") || "";
    currentAlt = currentAlt.trim();

    // Build new alt text
    const newAlt = `${index + 1} of ${totalImages}: ${currentAlt}`;

    // Set updated alt text
    img.setAttribute("alt", newAlt);
  });
});